function replaceCurrentRegion(pathname: string) {
  return `${pathname.replace(`/${process.env.REACT_APP_REGION}`, '')}`;
}

export function getBaseUrl(region: string, pathname: string) {
  return `${window.location.origin}/${region}${replaceCurrentRegion(pathname)}`;
}
